import { cssVar } from 'utils/css';

export const circularProgress = {
  colorPrimary: {
    color: cssVar('--primary'),
  },
};
